var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["custom-field-label-pane__render", _vm.field.field_type] },
    [
      _vm.value
        ? [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.formattedValue,
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [_vm._v(" " + _vm._s(_vm.value) + " ")]
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "custom-field-label-pane__render__no-data" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "PtCustomFieldLabelPane.render.noData." +
                          _vm.field.field_type
                      )
                    ) +
                    " "
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }